import { render, staticRenderFns } from "./CbtResultDetails.vue?vue&type=template&id=5aba8962"
import script from "./CbtResultDetails.vue?vue&type=script&lang=js"
export * from "./CbtResultDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports